<template>
	<label class="checkbox">
		<input
			class="checkbox__input"
			type="checkbox"
			v-model="check_calc"
		>

		<svg class="checkbox__check" width="24" height="24">
			<polyline points="20 6 9 17 4 12"></polyline>
		</svg>

		<span class="checkbox__text">
			<slot>
				Название поля
			</slot>
		</span>
	</label>
</template>

<style lang="scss" src="./MyCheckbox.scss"></style>

<script setup>
import {ref, computed} from 'vue'

const props = defineProps({
  choosed: [String], 
})
const emits = defineEmits([ 'input' ])

const check_calc = computed({
  get() {
    return props.choosed ? true : false
  },
  set(value) {
    let val=value ? '1' : '' 
    emits('input', val)
  }
})
</script>